import { 
  postVerifiCode,
  postRegister,
} from '@/apis/user';
import { maidianOpenreal } from '@/apis/common';
import { userCenterLoginUrl } from '@/config';
import { encryptCBC, appCode, getIMEI, getIpConfig } from "@/utils/IMEI";
import yidunCaptcha from '@/mixins/yidunCaptcha';

export default {
  mixins: [yidunCaptcha],
  data() {
    return {
      form: {
        phone: "",
        code: "",
      },
      // 控制显示验证码或读秒
      verControl: true,
      // 定时器倒计时
      refreshData:null,
      verSecond: 60,
    }
  },
  methods: {
    openLive() {
      window.open(
        this.$parent.live800UrlUc
      );
    },
    live800() {
      this.openLive();
    },
    toUserCenter() {
      window.location.href = userCenterLoginUrl;
    },
    // 输入手机号
    changePhone(e) {
      if(e.target.value) {
        maidianOpenreal({
          eventname: 'rr2',
          eventdescribe: '真实用户_开户填写手机号',
          detail: {
              mobile: e.target.value,
          },
          eventtype: 'input',
        });
      }
    },
    // 行为验证通过（或按配置跳过验证）后发送短信验证码，validate 由易盾返回
    sendSmsCode(validate) {
      const data = {
        sendType: '1',
        mobile: this.form.phone,
        validate,
      };
      postVerifiCode(data, {
        headers: {
          appcode: appCode()['channel'] || appCode()['v'] || 'N9999',
          imei: getIMEI(),
        }
      }).then((res) => {
        this.$message({
          message: res,
          type: "success",
        });
        this.verControl = !this.verControl;
        this.countdown();
        maidianOpenreal({ eventname: 'rr3', eventdescribe: '真实用户_发送验证码', eventtype: 'input' });
      });
    },
    // 点击获取验证码
    verCode(attr) {
      if (this.isPhone(attr)) {
        // 网易易盾行为验证通过后再发送验证码
        this.openYidunVerify(this.sendSmsCode);
      } else {
        this.$message({
          message: "请输入正确手机号!",
          type: "warning",
        });
      }
    },
    // 正则判断电话号码格式是否正确
    isPhone(TEL) {
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (strTemp.test(TEL)) {
        return true;
      }
      return false;
    },
    // 读秒
    countdown() {
      this.refreshData = window.setInterval(() => {
        this.verSecond--;
        if (this.verSecond < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(this.refreshData); //清除定时器
          this.verSecond = 60;
          this.verControl = true;
        }
      }, 1000);
    },
    // 注册
    handleRegister() {
      return new Promise(async (resolve, reject) => {
        const isWap = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const params = {
          ...ipInfo,
          appcode: appCode()['channel'] || appCode()['v'] || 'N9999',
          fromType: isWap ? 'wap' : 'pc',
          isMt5: 1,
          clientId: getIMEI(),
          mobile: this.form.phone,
          code: this.form.code,
          email: this.form.email,
          pwd: this.form.password ? encryptCBC(this.form.password) : undefined,
        };
        const ipInfo = await getIpConfig();
        maidianOpenreal({ eventname: 'rr4', eventdescribe: '真实用户_提交资料数', eventtype: 'input' });
        postRegister({...ipInfo, ...params}).then(res => {
          maidianOpenreal({
            eventname: 'rr5',
            eventdescribe: '真实开户_开户成功数',
            usertype: '2',
            medium: '',
            plan: '',
            account: res.account,
            accounttype: 2,
          });
          this.$message({
            message: '注册成功！',
            type: 'success',
          });
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}